import { render, staticRenderFns } from "./Produk.vue?vue&type=template&id=767c0389&scoped=true"
import script from "./Produk.vue?vue&type=script&lang=js"
export * from "./Produk.vue?vue&type=script&lang=js"
import style0 from "./Produk.vue?vue&type=style&index=0&id=767c0389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c0389",
  null
  
)

export default component.exports